/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Ruramba 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gabiro": ["Bukoro", "Kageyo", "Kansi", "Nyamirambo", "Ryamuhumbi"],
  "Giseke": ["Giseke", "Kabari", "Kidogo", "Matyazo", "Tugogo"],
  "Nyarugano": ["Gisorora", "Kinyonyo", "Nyarugano", "Uruyange"],
  "Rugogwe": ["Rugogwe", "Rugusa", "Titi"],
  "Ruramba": ["Bugizi", "Busasamana", "Karambi", "Ruramba"]
};